import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigProvider } from '@app/app.config.provider';
import { StoreActions } from '@models/store/store-actions';
import { IStoreState } from '@models/store/store-state';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ObservableStore } from '../observable-store/dist';

@Injectable({
  providedIn: 'root'
})
export class VintageService extends ObservableStore<IStoreState> {
  private vintageApiURL: string;
  private _startVintage: string;

  constructor(private readonly http: HttpClient, private readonly appConfig: AppConfigProvider) {
    super({ trackStateHistory: false });

    this.appConfig.environment.subscribe(env => {
      this.vintageApiURL = `${env.API.DECAY}/api/decay/vintage`;
    });
  }

  public getVintages(productId: number): Observable<string[]> {
    return this.fetchVintages(productId);
  }

  private fetchVintages(productId: number) {
    return this.http.get<string[]>(`${this.vintageApiURL}/${productId}`).pipe(
      map(vintageData => {
        const vintages = this.getState().vintages || {};
        vintages[productId] = vintageData;
        this.setState({ vintages }, StoreActions.SetVintages);
        return vintageData;
      }),
      catchError(this.handleError)
    );
  }

  private handleError(error: any) {
    console.error('server error:', error);
    if (error.error instanceof Error) {
      const errMessage = error.error.message;
      return throwError(errMessage);
    }
    return throwError(error || 'Server error');
  }

  set startVintage(startVintage: string) {
    if (startVintage && startVintage !== '0001-01-01T00:00:00') {
      this.setState({ startVintage }, StoreActions.SetStartVintage);
      this._startVintage = startVintage;
    }
  }

  get startVintage(): string {
    return this._startVintage;
  }
}
